const BACKEND_STORAGE_KEY = "casaGiuBackendUrl"

export const getBackendUrl = () => {
     if (typeof window === "undefined") {
          return "http://localhost:8080"
     }

     const configuredWindowUrl = window.CASA_GIU_BACKEND_URL
     if (configuredWindowUrl && configuredWindowUrl.trim()) {
          return trimTrailingSlash(configuredWindowUrl)
     }

     const storedUrl = window.localStorage.getItem(BACKEND_STORAGE_KEY)
     if (storedUrl && storedUrl.trim()) {
          return trimTrailingSlash(storedUrl)
     }

     return defaultBackendUrl()
}

export const setBackendUrl = (url) => {
     if (typeof window === "undefined") {
          return
     }

     const normalizedUrl = trimTrailingSlash(url || defaultBackendUrl())
     window.localStorage.setItem(BACKEND_STORAGE_KEY, normalizedUrl)
}

export const apiUrl = (path) => `${getBackendUrl()}${path}`

const defaultBackendUrl = () => {
     const { protocol, hostname, port, origin } = window.location
     if ((hostname === "localhost" || hostname === "127.0.0.1") && port === "3000") {
          return `${protocol}//${hostname}:8080`
     }
     return origin || `${protocol}//${hostname || "localhost"}`
}

const trimTrailingSlash = (value) => value.trim().replace(/\/+$/, "")
